import {
  useOrganizationConfig,
  usePortalCapabilities,
} from '@portals/api/organizations';
import {
  isCustomerFeatureAll,
  isCustomerFeatureLabOnly,
} from '@portals/framework';

export function useShouldDisplayOrganizationTenantMenu() {
  const portalCapabilities = usePortalCapabilities();
  const organizationConfig = useOrganizationConfig();

  return !(
    isCustomerFeatureAll(portalCapabilities?.b2c_view) ||
    isCustomerFeatureLabOnly(
      portalCapabilities?.b2c_view,
      organizationConfig?.lab
    )
  );
}
